<template>
  <div class="auth-layout">
    <div class="main va-row">
      <div class="auth-content flex xs12 fill-height">
        <v-container class="pa-sm-0" fluid>
          <keep-alive>
            <router-view/>
          </keep-alive>
        </v-container>
      </div>
    </div>
    <v-footer style="background-color:#009688 !important" padless>
      <v-row justify="center" no-gutters>
        <v-btn
          color="white"
          text
          link
          rounded
          class="my-2"
          target="_brank"
          href="https://www.kenchare.net/terms-of-service/index.html"
        >
          利用規約（個人向け）
        </v-btn>
        <v-btn
          color="white"
          text
          link
          rounded
          class="my-2"
          target="_brank"
          href="https://www.kenchare.net/terms-of-service-for-admin/index.html"
        >
          利用規約（所属団体管理者向け）
        </v-btn>
        <v-col class="text-center white--text" cols="12" style="background-color:#0B8E81 !important">
          健康チャレンジキャンペーン<span style="font-size:0.5rem">©®</span>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
  name: 'AuthLayout',
  components: { }
})
</script>

<style lang="scss">
.auth-layout {
  height: 100%;
  margin: 0;
  .main {
    margin: 0 0 50px 0;
    width: 100%;
    .auth-content {
      padding: 0;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
